<template>
  <div class="pls-nav-air">
    <div class="pls-nav-mod">
      <div class="pls-nav-left">
        <RouterLink to="/"><img id="header-img" width="173" height="63" class="header-img" src="@/assets/logo2.svg" />
        </RouterLink>
        <el-dropdown class="no-border-dropdown" popper-class="hide-dropdown-arrow" v-for="(item, index) in tablelist"
          :key="index" trigger="click">
          <span class="el-dropdown-link" @click="handleJump(item.route, item.id)">
            {{ item.name }}
          </span>
          <template v-if="item.children.length != 0" #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item v-for="child in item.children" :key="child.name"
                @click="handleJump1(child.route, child.id)"> {{ child.name }}</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
      <ul class="pls-nav-right">
        <li class="pls-nav-iphone">
          <img class="svg-icon" src="@/assets/phone.svg" /><span class="txt">{{t("phonenum")}}</span>
        </li>
        <li class="pls-nav-iphone">
          <el-select v-model="value1" style="width:160px;border: 0px;" @change="changeFUN">
            <template #label="{ label }">
              <img :src="label.url" style="width: 24px; height: 24px;vertical-align: middle" />
              <span style="font-weight: bold; margin-left: 8px;">{{ label.text }}</span>
            </template>
            <el-option v-for="item in options" :key="item.value" :label="item" :value="item.value">
              <img :src="item.url" style="width: 24px; height:24px;vertical-align:middle" />
              <span style="margin-left: 8px;">{{ item.text }}</span>
            </el-option>
          </el-select>
        </li>
      </ul>


    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n()
import { useRouter } from "vue-router";
const router = useRouter();
const value1 = ref('zh');
const options = ref([{
  value: 'zh',
  text: '中文',
  url: require("../assets/cn.svg"),
},
{
  value: 'en',
  text: 'EN',
  url: require("../assets/en.svg"),
},
])
const tablelist = computed(() => [
  {
    id: 1,
    name: t('menu.coreproduct'),
    children: [{
      id: 11,
      name: t('coreproductchildmenu.Rotarymilkingmachine'),
      route: "Coreproduct",
    },
    {
      id: 12,
      name: t('coreproductchildmenu.Fully'),
      route: "Coreproduct",
    },
    {
      id: 13,
      name: t('coreproductchildmenu.Intelligent'),
      route: "Coreproduct",
    },
    {
      id: 14,
      name: t('coreproductchildmenu.wearable'),
      route: "weatable",
    }
    ]
  },
  {
    id: 2, name: t('menu.service'),
    children: [
      {
        id: 21,
        name: t('servicechildmenu.service1'),
        route: "ourserver-0",
      },
      {
        id: 22,
        name: t('servicechildmenu.service2'),
        route: "ourserver-1",
      },
      {
        id: 23,
        name: t('servicechildmenu.service3'),
        route: "ourserver-2",
      },
      {
        id: 24,
        name: t('servicechildmenu.service4'),
        route: "ourserver-3",
      }

    ]
  },
  {
    id: 3, name: t('menu.sharingcenter'),
    route: "share",
    children: []
  },
  {
    id: 4, name: t('menu.about'), route: "about",
    children: []
  },
  {
    id: 5, name: t('menu.contactUs'), route: "contactus",
    children: []
  },

]);
const changeFUN = (value) => {
  locale.value = value
}
const handleJump = (routepram, id) => {
  if (routepram !== undefined) {
    router.push({ name: routepram, params: { id: id } })
    
  }
  // if (routepram === "contactus") {
  //   document.getElementById('sobot-ticket-iframe').style.display = 'block'
  // }else{
  //   document.getElementById('sobot-ticket-iframe').style.display = 'none'
  // }
  
};
const handleJump1 = (routepram, id) => {
  router.push({ name: routepram, params: { id: id } })

};
</script>
<style lang="scss" scoped>
.pls-nav-air {
  position: relative;
  z-index: 6;
  box-shadow: 5px 5px 6px rgb(93, 87, 88, 0.2);

  .pls-nav-mod {
    height: 100px;
    width: 1440px;
    margin: 0 auto;
    background: transparent;
    background: #fff;
    box-sizing: content-box;
    @include mix.flex-container(row);
    justify-content: space-between;
    color: vars.$base-color;

    .pls-nav-left {
      display: flex;

      .header-img {
        cursor: pointer;
        float: left;
        margin: 15px 40px 0px 20px;
      }

      .pls-nav-list {
        @include mix.flex-container(row);
        align-items: center;

        li {
          cursor: pointer;
          padding: 0 24px;
          height: 36px;
          margin-right: 4px;
          line-height: 36px;
          box-sizing: content-box;

          &:hover {
            background-color: vars.$base-color;
            line-height: 36px;
            border-radius: vars.$radius-4;
          }
        }

        li {
          position: relative;
          color: vars.$txt-color;
          font-weight: bold;

          &:after {
            display: block;
            content: "";
            position: absolute;
            top: 29px;
            right: 4px;
            width: 0px;
            height: 0px;
            margin-left: -5px;
            /* 根据需要调整 */
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-top: 5px solid #fff;
            transition: transform 0.1s;
          }
        }

        li:hover {
          position: relative;
          color: #fff;

          &:after {
            top: 33px;
            right: 4px;
            ;
            transform-origin: top;
            transform: rotate(-180deg);
          }
        }

        li:first-child {
          position: relative;

          &:after {
            display: block;
            content: "";
            position: absolute;
            top: 29px;
            right: 4px;
            width: 0px;
            height: 0px;
            margin-left: -5px;
            /* 根据需要调整 */
            border-left: 0px solid transparent;
            border-right: 0px solid transparent;
            border-top: 0px solid #fff;
            transition: transform 0.2s ease-in-out;
          }
        }

        li:first-child:hover {
          position: relative;
          color: #fff;

          &:after {
            top: 33px;
            right: 4px;
            ;
            transform-origin: top;
          }
        }
      }
    }

    .pls-nav-right {
      @include mix.flex-container(row);
      align-items: center;

      li {
        padding: 0 16px;
        height: 62px;
        line-height: 62px;
        box-sizing: content-box;
      }

      .pls-nav-iphone {
        min-width: 160px;

        .svg-icon {
          margin: 22px 5px 0px 0px;
          float: left;
          display: block;
          width:20px;
          height:20px;
        }

        a {
          color: #000;
        }

        .txt {
          font-size: 16px;
          font-weight: bold;
        }
      }

      .pls-nav-trial {
        cursor: pointer;
        background: vars.$base-color;
        color: #fff;
      }
    }
  }
}

.pls-nav-dropdown {
  z-index: 4;
  position: absolute;
  left: 0;
  top: 60;
  width: 100%;
  overflow: hidden;
  animation: slideInDown;
  animation-duration: 1s;
  background-color: #f1f2f5;
  box-shadow: rgba(55, 99, 170, 0.2) 8px 8px 20px 0px, #fff -8px -8px 20px 0px;

  .pls-nav-drop-box {
    width: 100%;
    box-sizing: border-box;
    height: 300px;
  }

  .pls-nav-dropdown-close {
    position: absolute;
    right: 40px;
    top: 20px;
    width: 32px;
    height: 32px;
    font-size: 24px;
    display: flex;
    z-index: 5;
    align-items: center;
    justify-content: center;
    color: vars.$base-color;
  }
}

:deep(.el-textarea__inner) {
  border-radius: 0px;
}

:deep(.el-input__inner),
.custom-border {
  border-radius: 0px;
  font-size: 14x;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

:deep(.el-select__wrapper) {
  font-size: 14px;
  border-radius: 0px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.custom-border,
.el-select-dropdown__item {
  border-radius: 0px;
  font-size: 14px !important;
  color: #333 !important;
}

//el-dropdown样式修改
.no-border-dropdown .el-dropdown-link {
  margin: 30px 20px 0px 20px;
  padding: 0px 0px;
  line-height: 32px;
  position: relative; 
  height: 32px;
  color: #333;
  cursor: pointer;
  font-size: vars.$font-16;
  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;           
    height: 2px;          
    background-color: vars.$base-color;;
    transform: scaleX(0);    
    transform-origin: center;  
    transition: transform 0.3s ease; 
  }
  &:hover {
    // background: vars.$base-color;
    color: vars.$base-color;
    // border-radius: vars.$radius-4;
    border-color: #fff;
    &::after {
    transform: scaleX(1);
    }
  }
}

// .no-border-dropdown :deep(.el-dropdown-link) {
//   // border: none !important;
//   outline: none !important;
//   box-shadow: none !important;
//   margin-top: 30px;
//   padding: 0px 20px;
//   line-height: 32px;
//   margin-top: 30px;
// }

// .no-border-dropdown :deep(.el-dropdown-link:hover) {
//   outline: none !important;
//   // background: vars.$base-color;
//   border-bottom:2px solid vars.$base-color;
//   color: vars.$base-color;
//   // border-radius: vars.$radius-4;

// }

:global(.hide-dropdown-arrow .el-popper__arrow) {
  display: none !important;
}

:global(.hide-dropdown-arrow) {
  margin-top: 25.5px;
  border-radius: 0px 0px 2px 2px !important;
  box-shadow: none !important;
  border: 0px !important;
}

:deep(.el-sub-menu .el-menu-item:hover),
:deep(.el-dropdown-menu__item:hover) {
  background-color: vars.$base-color !important;
  color: #fff !important;
}

:deep(.el-dropdown-menu__item:not(.is-disabled):focus) {
  background-color: vars.$base-color !important;
  color: #fff !important;
}

.svg-icon1 {
  width: 24px;
  height: 24px;
}

:deep(.el-select) {
  border: 1px solid transparent !important;
}

:deep(.el-select .el-select__wrapper) {
  box-shadow: none !important;

}

:deep(.el-select .el-select__wrapper.is-focused) {
  box-shadow: none !important;
}
</style>
